<template>
  <Toast />
  <HeaderHome :user="$store.state.user.prenom" />
  <div class="background">

    <!-- Colonne gauche : liste -->
    <div class="panel panel-list">

      <div class="panel-header">
        <div class="panel-header-left">
          <div>
            <p class="panel-label">Gestion</p>
            <h2 class="panel-title">Lieux de rendez-vous</h2>
          </div>
        </div>
        <button class="btn-add" @click="newLieu">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Nouveau lieu
        </button>
      </div>

      <div class="table-wrap">
        <DataTable
          :value="lieux"
          :rows="10"
          tableStyle="width:100%"
          v-model:selection="lieuSelected"
          selectionMode="single"
          responsiveLayout="scroll"
          :rowsPerPageOptions="[6, 10, 20, 50]"
          :paginator="true"
          @click="selectLieu"
        >
          <Column field="TypeLieu.label" header="Type" />
          <Column field="nom" header="Nom" />
          <Column field="adresse" header="Adresse" />
          <Column field="ville" header="Ville" />
          <Column field="codePostal" header="CP" />
          <Column field="groupe" header="Groupe" />
          <Column field="time" header="Temps" />
        </DataTable>
      </div>
    </div>

    <!-- Colonne droite : formulaire -->
    <div class="panel panel-form">

      <template v-if="showLieu == false">
        <div class="empty-state">
          <div class="empty-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
            </svg>
          </div>
          <p class="empty-title">Aucun lieu sélectionné</p>
          <p class="empty-sub">Cliquez sur un lieu dans la liste ou créez-en un nouveau</p>
        </div>
      </template>

      <template v-else>
        <div class="form-header">
          <h2 class="form-title">
            <span v-if="lieuSelected == null">Ajouter un lieu</span>
            <span v-else>Modifier le lieu</span>
          </h2>
          <p class="form-sub" v-if="lieuSelected != null">{{ lieuSelected.nom }}</p>
        </div>

        <div class="form-body">

          <!-- Type de lieu -->
          <div class="field-group">
            <label class="field-label">Type de lieu <span class="required">*</span></label>
            <select v-model="lieu.tpLieu" class="field-input">
              <option value="">Sélectionner un type</option>
              <template v-for="t in typeLieux" :key="t.id">
                <option :value="t.id">{{ t.label }}</option>
              </template>
            </select>
          </div>

          <!-- Nom + Adresse -->
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Nom <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Nom du lieu" v-model="lieu.nom" />
            </div>
            <div class="field-group">
              <label class="field-label">Adresse <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Adresse" v-model="lieu.adresse" />
            </div>
          </div>

          <!-- Ville + CP -->
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Ville <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Ville" v-model="lieu.ville" />
            </div>
            <div class="field-group">
              <label class="field-label">Code postal <span class="required">*</span></label>
              <input type="text" class="field-input" placeholder="Code postal" v-model="lieu.cp" />
            </div>
          </div>

          <!-- Groupe + Temps -->
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Groupe <span class="required">*</span></label>
              <input type="number" class="field-input" placeholder="Numéro de groupe" v-model="lieu.groupe" />
            </div>
            <div class="field-group">
              <label class="field-label">Temps <span class="optional">(optionnel)</span></label>
              <input type="number" class="field-input" placeholder="Durée en minutes" v-model="lieu.time" />
            </div>
          </div>

          <!-- Actions -->
          <div class="form-actions">
            <template v-if="lieuSelected == null">
              <button class="btn btn-primary" @click="postLieu" v-if="!loadValBtn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                Valider
              </button>
              <button v-else class="btn btn-primary" disabled>
                <i class="fa fa-spinner fa-spin"></i> Valider
              </button>
            </template>

            <template v-else>
              <button class="btn btn-primary" @click="putLieu" v-if="!loadValBtn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                Modifier
              </button>
              <button v-else class="btn btn-primary" disabled>
                <i class="fa fa-spinner fa-spin"></i> Modifier
              </button>
              <button class="btn btn-danger" @click="deleteLieu" v-if="!loadValBtn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
                Supprimer
              </button>
              <button v-else class="btn btn-danger" disabled>
                <i class="fa fa-spinner fa-spin"></i> Supprimer
              </button>
            </template>
          </div>

        </div>
      </template>
    </div>

  </div>
</template>

<script>
import { useToast } from "primevue/usetoast";
import HeaderHome from "@/components/home/HeaderHome.vue";

export default {
  name: "AgenceDossier",
  components: {
    HeaderHome,
  },
  data() {
    return {
        toast: useToast(),
        lieux : [],
        typeLieux : [],
        showLieu : false,
        lieuSelected: null,
        lieu : {
            tpLieu : "",
            nom : "",
            adresse : "",
            ville : "",
            cp : "",
            groupe : "",
            time : ""
        },
        loadValBtn : false,
    }
  },

  mounted() {
    this.getLieux();
  },

  methods: {

    goToHome() {
      this.$router.push({ name: "Home" });
    },

    newLieu() {
      this.lieuSelected = null;
      this.lieu.tpLieu = "";
      this.lieu.nom = "";
      this.lieu.adresse = "";
      this.lieu.ville = "";
      this.lieu.cp = "";
      this.lieu.groupe = "";
      this.lieu.time = "";
      this.showLieu = true;
    },

    deleteLieu(){
        if (confirm("Es-tu sûr de vouloir supprimer ce lieu ?")){
            this.loadValBtn = true;
            window.api
                .delete("/lieus/"+this.lieuSelected.id, {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                })
                .then((response) => {
                    this.lieux = response.data.lieux
                    this.loadValBtn = false;
                    this.lieu.tpLieu = "";
                    this.lieu.nom = "";
                    this.lieu.adresse = "";
                    this.lieu.ville = "";
                    this.lieu.cp = "";
                    this.lieu.groupe = "";
                    this.lieu.time = "";
                    this.lieuSelected = null;
                    this.showLieu = false;
                    this.getLieux();
                    this.toast.add({ severity: "success", summary: "Lieu supprimé", detail: "Le lieu a été supprimé avec succès", life: 3000 });
                })
                .catch((error) => {
                console.log(error);
                this.loadValBtn = false;
                this.toast.add({ severity: "error", summary: "Erreur", detail: "Vous ne pouvez pas supprimer ce lieu", life: 3000 });
                });
        }
    },

    postLieu(){
        this.loadValBtn = true;
        if(this.lieu.tpLieu == "" || this.lieu.nom == "" || this.lieu.adresse == "" || this.lieu.ville == "" || this.lieu.cp == "" || this.lieu.groupe == ""){
            alert("Veuillez saisir tous les champs obligatoires");
            this.loadValBtn = false;
        }else{

            let time = null;

            if(this.lieu.time != ""){
                time = this.lieu.time;
            }

            window.api
            .post(
                "/lieus",
                {
                    TypeLieu : "api/type_lieus/" + this.lieu.tpLieu,
                    nom : this.lieu.nom,
                    adresse : this.lieu.adresse,
                    ville : this.lieu.ville,
                    codePostal: this.lieu.cp,
                    groupe : this.lieu.groupe,
                    time: time
                },
                {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                }
            )
            .then(() => {
                this.loadValBtn = false;
                this.lieu.tpLieu = "";
                this.lieu.nom = "";
                this.lieu.adresse = "";
                this.lieu.ville = "";
                this.lieu.cp = "";
                this.lieu.groupe = "";
                this.lieu.time = "";
                this.getLieux();
                this.toast.add({ severity: "success", summary: "Lieu ajouté", detail: "Le lieu a été créé avec succès", life: 3000 });
            })
            .catch((error) => {
                console.log(error);
                this.loadValBtn = false;
                this.toast.add({ severity: "error", summary: "Erreur", detail: "Une erreur est survenue lors de la création", life: 3000 });
            });
        }

    },

    putLieu(){
        this.loadValBtn = true;
        if(this.lieu.tpLieu == "" || this.lieu.nom == "" || this.lieu.adresse == "" || this.lieu.ville == "" || this.lieu.cp == "" || this.lieu.groupe == ""){
            alert("Veuillez saisir tous les champs obligatoires");
            this.loadValBtn = false;
        }else{

            let time = null;

            if(this.lieu.time != ""){
                time = this.lieu.time;
            }

            window.api
            .put(
                "/lieus/"+this.lieuSelected.id,
                {
                    TypeLieu : "api/type_lieus/" + this.lieu.tpLieu,
                    nom : this.lieu.nom,
                    adresse : this.lieu.adresse,
                    ville : this.lieu.ville,
                    codePostal: this.lieu.cp,
                    groupe : this.lieu.groupe,
                    time: time
                },
                {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                }
            )
            .then(() => {
                this.loadValBtn = false;
                this.getLieux();
                this.toast.add({ severity: "success", summary: "Lieu modifié", detail: "Le lieu a été mis à jour avec succès", life: 3000 });
            })
            .catch((error) => {
                console.log(error);
                this.loadValBtn = false;
                this.toast.add({ severity: "error", summary: "Erreur", detail: "Une erreur est survenue lors de la modification", life: 3000 });
            });
        }

    },

    selectLieu(){
        this.lieu.tpLieu = "";
        this.lieu.nom = "";
        this.lieu.adresse = "";
        this.lieu.ville = "";
        this.lieu.cp = "";
        this.lieu.groupe = "";
        this.lieu.time = "";

        this.lieu.tpLieu = this.lieuSelected.TypeLieu.id;
        this.lieu.nom = this.lieuSelected.nom;
        this.lieu.adresse = this.lieuSelected.adresse;
        this.lieu.ville = this.lieuSelected.ville;
        this.lieu.cp = this.lieuSelected.codePostal;
        this.lieu.groupe = this.lieuSelected.groupe;
        if(this.lieuSelected.time != "null"){
            this.lieu.time = this.lieuSelected.time;
        }
        
        this.showLieu = true;
    },

    getLieux(){
        window.api
            .get("/agence/lieux", {
            headers: {
                Authorization: "Bearer " + this.$store.state.token,
            },
            })
            .then((response) => {
                this.lieux = response.data.lieux
            })
            .catch((error) => {
            console.log(error);
            });

        window.api
        .get("/type_lieus", {
            headers: {
                Authorization: "Bearer " + this.$store.state.token,
            },
            })
            .then((response) => {
                this.typeLieux = response.data["hydra:member"]
            })
            .catch((error) => {
            console.log(error);
            });
    }

  },
};
</script>

<style scoped>

/* ── Layout principal ── */
div.background {
  min-height: 100vh;
  width: 100%;
  background: #f4f6f9;
  display: flex;
  gap: 20px;
  padding: 24px;
  box-sizing: border-box;
}

/* ── Panneaux ── */
.panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-list {
  flex: 1 1 60%;
  min-width: 0;
}

.panel-form {
  flex: 0 0 38%;
  max-width: 480px;
}

/* ── En-tête panneau liste ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  gap: 12px;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.panel-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  text-align: left;
}

.panel-title {
  margin: 2px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  text-align: left;
}

/* ── Bouton "Nouveau lieu" ── */
.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s;
}

.btn-add:hover {
  background: #2563eb;
}

/* ── Tableau ── */
.table-wrap {
  padding: 16px;
  flex: 1;
  overflow: auto;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 14px;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  font-size: 13px;
  color: #334155;
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f0f7ff !important;
  cursor: pointer;
}

:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #eff6ff !important;
  color: #1d4ed8;
}

:deep(.p-paginator) {
  background: transparent;
  border: none;
  padding: 8px 0 4px;
  font-size: 13px;
}

/* ── État vide ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 48px 32px;
  text-align: center;
}

.empty-icon {
  width: 72px;
  height: 72px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.empty-title {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
}

.empty-sub {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
  max-width: 240px;
  line-height: 1.5;
}

/* ── En-tête formulaire ── */
.form-header {
  padding: 20px 24px 0;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
}

.form-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.form-sub {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

/* ── Corps du formulaire ── */
.form-body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.field-row {
  display: flex;
  gap: 14px;
}

.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.optional {
  color: #94a3b8;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  margin-left: 4px;
  font-size: 11px;
}

.field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.18s, background 0.18s;
  appearance: auto;
}

.field-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}

/* ── Actions ── */
.form-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, opacity 0.18s;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-primary {
  background: #3b82f6;
  color: #ffffff;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.btn-danger {
  background: #fee2e2;
  color: #dc2626;
}

.btn-danger:hover:not(:disabled) {
  background: #fecaca;
}

</style>
